import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import CustomModal from "../CustomModal/CustomModal";
import { APPROVAL_NOTICE_EVENT, EVENT_APPROVAL_MESSAGE } from "../../../utils/approval";
// Same dialog look as the account status popup
import "../AccountStatusModal/AccountStatusModal.scss";

// Popup telling a student that what they just created goes live only after their institution approves it.
// Mounted once in App.js and opened with showApprovalNotice() from utils/approval, so it stays on screen after
// the create form has closed. message: null = closed.
const ApprovalNotice = () => {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const open = (e) => setMessage(e.detail?.message || EVENT_APPROVAL_MESSAGE);
    window.addEventListener(APPROVAL_NOTICE_EVENT, open);
    return () => window.removeEventListener(APPROVAL_NOTICE_EVENT, open);
  }, []);

  const close = () => setMessage(null);

  return (
    <CustomModal show={message !== null} onClose={close} title="" className="account-status-modal">
      <div className="account_status_container">
        <div className="account_status_icon">
          <Clock size={26} strokeWidth={1.8} aria-hidden="true" />
        </div>
        <h2>Sent for approval</h2>
        <p>{message}</p>
        <button type="button" className="account_status_btn" onClick={close}>
          Got it
        </button>
      </div>
    </CustomModal>
  );
};

export default ApprovalNotice;
